import { IRogue } from "../services/RogueTypes"

export function getTargetBackend(env: IRogue['env']) {
  if (env === 'test') {
    return 'm2test'
  }
  
  if (env === 'sprint') {
    return 'm2sprint'
  }

  if (env === 'staging') {
    return 'm2staging'
  }

  return 'www'
}
